import { lazy } from 'react'

export const PutPhoneAwayVariant1 = lazy(() => import('./PutPhoneAwayVariant1'))
